import React, { useState } from "react";
import { useBoolean } from "ahooks-v2";
import { BottomFillIcon, TopFillIcon } from "@t8891/icon";
import SplitText from "@Components/SplitText";

const RegionItem: React.FC<any> = ({ visible, setVisible, regionName, dataSource, toggleSelect, onSelectIndex }) => {
  return (
    <div id={"Item"} className=''>
      <div
        className='w-228 pl-10 rounded-4 border-1 border-solid border-[#e8e8e8] relative inline-flex items-center text-14 cursor-pointer h-32 leading-32 bg-white'
        data-value={regionName}
        style={{ color: regionName.includes("請選擇") ? "#bbb" : "#333" }}
        onClick={() => {
          if (Object.keys(dataSource).length !== 0) {
            setVisible(1);
          } else {
            toggleSelect(true);
          }
        }}
      >
        {regionName === "請選擇地區" ? "請選擇縣市" : regionName}
        <div className='absolute right-4 flex flex-col item-center'>
          {visible === 1 ? <TopFillIcon size={22} /> : <BottomFillIcon size={22} />}
        </div>
      </div>
      {visible === 1 && Object.keys(dataSource).length !== 0 && (
        <section
          className='w-500 bg-[#fff] rounded-4 border-solid border-[#e8e8e8] text-[#333] text-14 pt-20 px-18 top-30 left-80  absolute'
          style={{ boxShadow: "0px 8px 20px 0px rgba(0, 0, 0, 0.1)", zIndex: 1 }}
        >
          {dataSource.parts?.map((v, i: number) => (
            <div className='mb-20' key={i}>
              <label className='inline-block font-black'>{v.name}</label>
              <ul className='inline-block font-normal text-[#999] cursor-pointer hover:text-[#3264ff]'>
                {Array.isArray(v.regions) &&
                  v.regions.map((vv: any, ii: number) => (
                    <li
                      className={`inline-block font-normal ${
                        regionName === dataSource.regions[vv].name ? "text-[#3264ff]" : "text-[#999] "
                      } ml-20 cursor-pointer hover:text-[#3264ff]`}
                      key={ii}
                      onClick={() => {
                        onSelectIndex(vv, dataSource.regions[vv].name, "region");
                        setVisible(2);
                      }}
                    >
                      {dataSource.regions[vv].name}
                    </li>
                  ))}
              </ul>
            </div>
          ))}
        </section>
      )}
    </div>
  );
};

const SectionItem: React.FC<any> = ({
  visible,
  setVisible,
  sectionName,
  dataSource,
  toggleSelect,
  onSelectIndex,
  disabled,
}) => {
  return (
    <div id={"Item"} className=''>
      <div
        className={`cursor-pointer bg-white w-108 pl-10 rounded-4 border-1 border-solid border-[#e8e8e8] relative inline-flex items-center text-14  h-32 leading-32 `}
        data-value={sectionName}
        style={{ color: sectionName === "請選擇區域" ? "#bbb" : "#333" }}
        onClick={() => {
          if (disabled) {
            setVisible(1);
            return;
          }
          if (Object.keys(dataSource).length !== 0) {
            setVisible(2);
          } else {
            toggleSelect(true);
          }
        }}
      >
        {sectionName === "請選擇區域" ? "請選擇區域" : sectionName}
        <div className='absolute right-4 flex flex-col item-center'>
          {visible == 2 ? <TopFillIcon size={22} /> : <BottomFillIcon size={22} />}
        </div>
      </div>
      {visible == 2 && Object.keys(dataSource).length !== 0 && (
        <section
          className='max-w-400 bg-[#fff] rounded-4 grid grid-cols-5 text-[#333] text-14 pt-20 px-18 top-30 left-120 gap-10  absolute'
          style={{
            boxShadow: "0px 8px 20px 0px rgba(0, 0, 0, 0.1)",
            zIndex: 1,
            border: "1px solid #e8e8e8",
          }}
        >
          {dataSource.map((item: any, index: number) => (
            <div className='mb-14' key={index}>
              <div
                className={`text-center font-normal ${
                  sectionName === item.name ? "text-[#3264ff]" : "text-[#999] "
                } cursor-pointer hover:text-[#3264ff]`}
                key={index}
                onClick={() => {
                  onSelectIndex(item.value, item.name, "section");
                  setVisible(3);
                }}
              >
                {item.name}
              </div>
            </div>
          ))}
        </section>
      )}
    </div>
  );
};

const DealerItem: React.FC<any> = ({
  visible,
  setVisible,
  dealerName,
  dataSource,
  toggleSelect,
  disabledRegion,
  onSelectIndex,
  disabled,
}) => {
  return (
    <div id={"Item"} className=''>
      <div
        className={`w-134 cursor-pointer bg-white pl-10 rounded-4 border-1 border-solid border-[#e8e8e8] relative inline-flex items-center text-14  h-32 leading-32  ellipsis`}
        data-value={dealerName}
        id='DealerItem'
        style={{ color: dealerName === "請選擇展示中心" ? "#bbb" : "#333" }}
        onClick={() => {
          if (disabled) {
            setVisible(disabledRegion ? 1 : 2);
            return;
          }
          if (Object.keys(dataSource).length !== 0) {
            setVisible(2);
          } else {
            toggleSelect(true);
          }
        }}
      >
        <div className='ellipsis w-110'>{dealerName === "請選擇展示中心" ? "請選擇展示中心" : dealerName}</div>
        <div className='absolute right-4 flex flex-col item-center'>
          {visible === 2 ? <TopFillIcon size={22} /> : <BottomFillIcon size={22} />}
        </div>
      </div>
      {visible === 2 && Object.keys(dataSource).length !== 0 && (
        <section
          className='min-w-300  bg-[#fff] rounded-4 flex flex-col text-[#333] text-14 pt-20 px-18 top-30 -right-86  absolute'
          style={{
            boxShadow: "0px 8px 20px 0px rgba(0, 0, 0, 0.1)",
            zIndex: 1,
            border: "1px solid #e8e8e8",
          }}
        >
          {dataSource.map((item: any, index: number) => (
            <div className='mb-14' key={index}>
              <div
                className={`inline-block font-normal ${
                  dealerName === item.name ? "text-[#3264ff]" : "text-[#999] "
                } cursor-pointer hover:text-[#3264ff]`}
                onClick={() => {
                  onSelectIndex(item.value, item.name, "dealer");
                  setVisible(0);
                }}
              >
                {item.name}
              </div>
            </div>
          ))}
        </section>
      )}
    </div>
  );
};

interface IProps {
  onSelectIndex: (index: number, name: string) => void;
  formData: any;
  kindData: any;
  toggleSelect?: any;
  dataSource: {
    selectedIndex: number;
    hotRegions: number[];
    regions: {
      id: number;
      name: string;
    }[];
    parts: {
      name: string;
      regions: number[];
    }[];
  };
}

const AdRegionItem = ({ formData, dataSource, onSelectIndex, toggleSelect, kindData }: IProps) => {
  const { regionName, sectionName, dealerName, region, section } = formData;
  const { rosterConfig } = kindData;

  const [visible, setVisible] = useState<number>(-1);

  return (
    <>
      <section className='w-full relative mb-24 flex items-center' id='AdRegionItem'>
        <div className={`w-86 relative flex`}>
          <span className='absolute text-[#ff4333] -left-10 to-4'>*</span>
          <SplitText label='地區' width={64} cls='text-[#333] font-medium text-16 leading-18'></SplitText>：
        </div>
        <div className='flex gap-12'>
          <RegionItem
            regionName={regionName}
            dataSource={dataSource}
            visible={visible}
            setVisible={setVisible}
            toggleSelect={toggleSelect}
            onSelectIndex={onSelectIndex}
          />
          {/* <SectionItem
            sectionName={sectionName}
            disabled={!region}
            visible={visible}
            setVisible={setVisible}
            dataSource={rosterConfig?.section[region]}
            toggleSelect={toggleSelect}
            onSelectIndex={onSelectIndex}
          /> */}
          <DealerItem
            dealerName={dealerName}
            dataSource={rosterConfig?.dealer[region]}
            disabledRegion={!region}
            disabled={!region}
            visible={visible}
            setVisible={setVisible}
            toggleSelect={toggleSelect}
            onSelectIndex={onSelectIndex}
          />
        </div>
      </section>
    </>
  );
};

export default AdRegionItem;
